import qaRoutes from '@/router/quality_assurance'

import store from '@/store'
function isFacilityOwner (to) {
    return to.params?.facilityId &&  store.state.auth.national_facility_ids.includes(to.params.facilityId)
}
const ownerOrPermissionsGate = (to, acceptedPermissions) => (acceptedPermissions.some(p => store.state.auth.permissions.includes(p)) || isFacilityOwner (to))

const viewFacilityPermissions = [ "view-all-nf" ]
const viewIaPermissions = [
    "cars-review-nf", "cars-review-lidar", "cars-review-lidar-data", "cars-review-photometer",
    "cars-review-photometer-data", "cars-view-ia-submission", "cars-view-ia-report"
]

const routes = [
    {
        path: '/facility/:facilityId',
        name: 'NationalFacilityPage',
        component: () => import('@/pages/facilities/NationalFacility.vue'),
        props: true,
        meta: {
            title: 'National Facility',
            auth: true,
            label: 'National Facility',
            gate: (to) => ownerOrPermissionsGate(to, viewFacilityPermissions)
        },
        redirect: { name: 'FacilityProfile' },
        children: [
            {
                path: 'profile', name: 'FacilityProfile', component: () => import('@/views/facility/FacilityProfile.vue'), redirect: {name: 'FacilityGeneralInformation'}, props: true, meta: { label: 'Profile', hide: true, auth: true },
                children: [
                    { path: 'information', name: 'FacilityGeneralInformation', component: () => import('@/views/facility/FacilityGeneralInformation.vue'), props: true, meta: { label: 'General Information', auth: true } },
                    { path: 'lidars', name: 'FacilityLidars', component: () => import('@/views/facility/cars/FacilityLidars.vue'), props: true, meta: { label: 'Lidar Systems', auth: true }, },
                    { path: 'photometers', name: 'FacilityPhotometers', component: () => import('@/views/facility/cars/FacilityPhotometers.vue'), props: true, meta: { label: 'Photometer Systems', auth: true }, }
                ]
            },
            {
                path: 'initial-acceptance', name: 'FacilityIa', component: () => import('@/views/facility/cars/initial_acceptance/FacilityIa.vue'), redirect: {name: 'FacilityIaSynergy'}, props: true, meta: { label: 'Initial Acceptance', hide: true, auth: true, gate: (to) => ownerOrPermissionsGate(to, viewIaPermissions) },
                children: [
                    { path: 'documents', name: 'FacilityIaDocuments', component: () => import('@/views/facility/cars/initial_acceptance/InitialAcceptanceDocuments.vue'), props: true, meta: { label: 'Documents', auth: true, gate: (to) => ownerOrPermissionsGate(to, viewIaPermissions) } },
                    { path: 'synergy', name: 'FacilityIaSynergy', component: () => import('@/views/facility/cars/initial_acceptance/SynergyCompliance.vue'), props: true, meta: { label: 'Synergy', auth: true, gate: (to) => ownerOrPermissionsGate(to, viewIaPermissions) } },
                    { path: 'lidar', name: 'FacilityIaLidar', component: () => import('@/views/facility/cars/initial_acceptance/LidarComplianceTable.vue'), props: true, meta: { label: 'Lidar', auth: true, gate: (to) => ownerOrPermissionsGate(to, viewIaPermissions) } },
                    { path: 'photometer', name: 'FacilityIaPhotometer', component: () => import('@/views/facility/cars/initial_acceptance/PhotometerComplianceTable.vue'), props: true, meta: { label: 'Photometer', auth: true, gate: (to) => ownerOrPermissionsGate(to, viewIaPermissions) } },
                ]
            },
            {
                path: 'quality-assurance', name: 'FacilityQa', component: () => import('@/views/facility/cars/quality_assurance/FacilityQa.vue'), redirect: { name: 'QaHome' }, meta: { label: 'Quality Assurance', hide: false, auth: true }, props: true, children: qaRoutes
            }
        ],
    }
]

export default routes